import { render, staticRenderFns } from "./FieldsForm.vue?vue&type=template&id=3942316e&scoped=true"
import script from "./FieldsForm.vue?vue&type=script&lang=js"
export * from "./FieldsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3942316e",
  null
  
)

export default component.exports